import type { LabelHTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/cn'

type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  required?: boolean
  children: ReactNode
}

export function Label({ required, className, children, ...rest }: LabelProps) {
  return (
    <label
      className={cn(
        'mb-1 block text-[11px] font-medium uppercase tracking-wide text-gray-500',
        className,
      )}
      {...rest}
    >
      {children}
      {required && <span className="ml-0.5 text-red-500">*</span>}
    </label>
  )
}
